module.exports = __webpack_public_path__ + "static/media/ttb_logo_main_no_gradient.e5f47930.svg";